// extracted by mini-css-extract-plugin
module.exports = {"list":"InlineLanguages_list__e_2dC","item":"InlineLanguages_item__Pdhfo","active":"InlineLanguages_active__aKrBT"};